import { render } from "./Styleguide-FieldUsage-RichText.vue?vue&type=template&id=975955b2"
import script from "./Styleguide-FieldUsage-RichText.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-RichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__